var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeditLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "medit"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Union"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 3.25C1 4.49219 2.00781 5.5 3.25 5.5C3.85938 5.5 4.42188 5.26562 4.82031 4.89062L7.02344 5.99219C7.02344 6.0625 7.02344 6.15625 7.02344 6.25C7.02344 6.34375 7.02344 6.4375 7.02344 6.53125L4.82031 7.63281C4.42188 7.25781 3.85938 7 3.25 7C2.00781 7 1 8.00781 1 9.25C1 10.4922 2.00781 11.5 3.25 11.5C4.51562 11.5 5.5 10.4922 5.5 9.25C5.5 9.15625 5.5 9.0625 5.5 8.99219L7.70312 7.89062C8.10156 8.26562 8.66406 8.5 9.25 8.5C10.5156 8.5 11.5 7.49219 11.5 6.25C11.5 5.00781 10.5156 4 9.25 4C8.66406 4 8.10156 4.25781 7.70312 4.63281L5.5 3.53125C5.5 3.4375 5.5 3.34375 5.5 3.25C5.5 2.00781 4.51562 1 3.25 1C2.00781 1 1 2.00781 1 3.25ZM9.27344 7C8.85156 7 8.52344 6.67188 8.52344 6.25C8.52344 5.85156 8.85156 5.5 9.27344 5.5C9.67188 5.5 10.0234 5.85156 10.0234 6.25C10.0234 6.67188 9.67188 7 9.27344 7ZM3.25 2.5C3.67188 2.5 4 2.85156 4 3.25C4 3.67188 3.67188 4 3.25 4C2.85156 4 2.5 3.67188 2.5 3.25C2.5 2.85156 2.85156 2.5 3.25 2.5ZM3.25 10C2.85156 10 2.5 9.67188 2.5 9.25C2.5 8.85156 2.85156 8.5 3.25 8.5C3.67188 8.5 4 8.85156 4 9.25C4 9.67188 3.67188 10 3.25 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 3.25C5 4.07843 4.32843 4.75 3.5 4.75C2.67157 4.75 2 4.07843 2 3.25C2 2.42157 2.67157 1.75 3.5 1.75C4.32843 1.75 5 2.42157 5 3.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 9.25C5 10.0784 4.32843 10.75 3.5 10.75C2.67157 10.75 2 10.0784 2 9.25C2 8.42157 2.67157 7.75 3.5 7.75C4.32843 7.75 5 8.42157 5 9.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 6.25C11 7.07843 10.3284 7.75 9.5 7.75C8.67157 7.75 8 7.07843 8 6.25C8 5.42157 8.67157 4.75 9.5 4.75C10.3284 4.75 11 5.42157 11 6.25Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeditLogo);
export default __webpack_public_path__ + "static/media/medit_logo.9a504354d49666f75064ba9af83fa88b.svg";
export { ForwardRef as ReactComponent };